import Axios from 'axios';
import VueCookies from 'vue-cookies' // cookies
import Router from '../router';
import qs from 'qs';
Axios.interceptors.request.use((config) => {
    config.headers.Authorization = VueCookies.get('drcnet_token');
    // config.headers.Authorization = "2258adca6e4745f99490f146b322df78"
    if (config.method === 'post') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        config.transformRequest = [function(data, headers) {
            return qs.stringify(data);
        }];
    } else if (config.method === 'get') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        config.transformRequest = [function(data, headers) {
            return qs.stringify(data);
        }];
    }
    return config;
}, (err) => {
    console.log(err);
    return Promise.reject(err);
});
// Axios.interceptors.response.use(
//     response => {
//       // IE 8-9 
//       if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
//         try {
//           // eslint-disable-next-line no-param-reassign
//           response.data = JSON.parse(response.request.responseText);
//         } catch (e) {
//           // ignored
//         }
//       }
//       return response;
//     }
//   )
Axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    // vant.Toast.fail("身份验证失败，请关闭重新进入。");
                    // console.log('身份验证失败')
                    // Router.push('/login');
                    break;
                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token和清空vuex中token对象
                    // 跳转登录页面
                case 403:
                    // vant.Toast.fail("登录过期，请关闭重新进入。");
                    // 清除token
                    break;

                    // 404请求不存在
                case 404:
                    // vant.Toast.fail("您访问的网页不存在。");
                    break;
                    // 其他错误，直接抛出错误提示
                default:
                    // vant.Toast.fail(error.response.data.message);
            }
            return Promise.reject(error.response);
        }
    }
);

// Axios.defaults.baseURL = '/front' //设置axios默认请求地址 打包用
// Axios.defaults.baseURL = 'https://caselib.drcnet.com.cn/front' //设置axios默认请求地址 本地用
// Axios.defaults.baseURL = 'http://30.0.0.229/front' //设置axios默认请求地址 本地用
// ********************************************************************************************
Axios.defaults.baseURL = 'https://caselib.drcnet.com.cn/front' //设置axios默认请求地址

// ********************************************************************************************
// Axios.defaults.baseURL = '/api' //设置axios默认请求地址
// Axios.defaults.baseURL = 'https://casetest.drcnet.com.cn/front' //设置axios默认请求地址
export default Axios;


// WEBPACK FOOTER //
// ./src/api/axios.js